import HomePage from '@/views/home-manage/index'
import Datadeletion from '@/views/datadeletion-manage/index'

export default [
  {
    path: '/',
    component: HomePage,
    name: 'Index',
    children: [],
  },
  {
    path: '/datadeletion',
    component: Datadeletion,
    name: 'datadeletion',
    children: [],
  },
]
